import { createPinia } from 'pinia'

// 单例模式获取 pinia对象
export const PiniaSingleton = (function () {
  let instance

  function createInstance () {
    return createPinia()
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance()
      }
      return instance
    }
  }
})()
